/*
 * Build a shallow example object from an arbitrary source to constrain
 * denormalization depth in the normalizer.
 *
 * Rules:
 * - primitives/Dates are returned as-is
 * - arrays become []
 * - objects with an id keep only { id }
 * - other objects become a shallow map with only primitives/Dates preserved
 *   and nested objects reduced to {} unless they have an id
 */
export function buildRollbackExampleFromSource(source: unknown): unknown {
	if (source === null || typeof source !== 'object' || source instanceof Date) {
		return source;
	}

	if (Array.isArray(source)) {
		return [];
	}

	const obj = source as Record<string, unknown>;
	if (typeof obj.id === 'string') {
		return { id: obj.id } as const;
	}

	const shallow: Record<string, unknown> = {};
	Object.entries(obj).forEach(([key, value]) => {
		if (value === null || typeof value !== 'object' || value instanceof Date) {
			shallow[key] = value;
		} else if (Array.isArray(value)) {
			shallow[key] = [];
		} else {
			const vObj = value as Record<string, unknown>;
			shallow[key] = typeof vObj.id === 'string' ? { id: vObj.id } : {};
		}
	});

	return shallow;
}
